import React from "react";
import ReactDOM from "react-dom";

import "./sticky-listen-or-watch-live-actions";

import ListenOrWatchLive from "./ListenOrWatchLive";

const listenOrWatchLiveContainer = document.querySelector(
  "[data-listen-or-watch-live]"
);
if (listenOrWatchLiveContainer) {
  ReactDOM.render(<ListenOrWatchLive />, listenOrWatchLiveContainer);
}

const BASE_URL = ((env = process.env.APP_ENV) => {
  switch (env) {
    case "dev":
    case "development": {
      return "https://dev.bruzz.be";
    }
    case "stag":
    case "staging": {
      return "https://stag.bruzz.be";
    }
    case "prod":
    case "production":
    default: {
      return "https://www.bruzz.be";
    }
  }
})();

const openPopup = (type) => () => {
  /* It should be at least about 440px, since otherwise the Tidio (chat) function looks weird */
  return window.open(
    `${BASE_URL}/live/popup#${type}`,
    "popup",
    "width=440,height=710"
  );
};

const $popupTriggers = [...document.querySelectorAll(".js-open-live-popup")];

if ($popupTriggers) {
  $popupTriggers.map(($trigger) => {
    return ($trigger.onclick = openPopup($trigger.dataset.type));
  });
}

const showChatIfLivePageAndApp = async () => {
  const $element = document.querySelector("[data-tidio-url]");
  // console.log($element);

  if ($element) {
    const { default: loadjs } = await import("loadjs");
    // console.log($element.dataset.tidioUrl);
    loadjs($element.dataset.tidioUrl);
  }
};

showChatIfLivePageAndApp();
